import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslationService } from '../../services/translation/translation.service';
import { EnvConfig } from '../../services/config/env-config';

/**
 * Footer component is always shown on the bottom of the page
 */
@Component({
    selector: 'tw-footer',
    templateUrl: 'footer.html',
    styleUrls: ['footer.scss']
})
export class FooterComponent implements OnInit {

    /**
     * User language used for urls
     */
    public userLanguage: string;

    /**
     * Current year used for copyright label
     */
    public currentYear: number;

    /**
     * Build version comes from env.json
     */
    public buildVersion: string;

    /**
     * The "constructor"
     * @param {HttpClient} http
     * @param {TranslationService} translate
     */
    constructor(private http: HttpClient,
                private translate: TranslationService) {
    }

    /**
     * Init of footer component: set user lang, current year, build version
     */
    public ngOnInit() {
        this.userLanguage = this.translate.currentLang;
        this.currentYear = (new Date()).getFullYear();
        this.initBuildVersion();
    }

    /**
     * Scrolls to top when click 'Back to top', scrolls baron__scroller in order list table with animation
     */
    public scrollToTop() {
        $('.baron__scroller').animate({
            scrollTop: 0
        }, 500);
    }

    /**
     * Get build version from env.json and put it to the footer
     */
    private initBuildVersion() {
        this.http.get('../../../assets/config/env.json')
            .toPromise()
            .then(data => {
                let env = new EnvConfig();
                Object.assign(env, data);
                this.buildVersion = env.buildVersion;
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/footer/footer.component.ts